import { Maybe, Scalars } from '~/client/graph'
import ApiHelper from '~/client/src/shared/utils/ApiHelper'

const mapboxBase = '/mapbox'
export interface IS3Config {
  /** AccessKeyId. */
  accessKeyId?: Maybe<Scalars['String']['output']>
  /** Bucket. */
  bucket?: Maybe<Scalars['String']['output']>
  /** Key. */
  key?: Maybe<Scalars['String']['output']>
  /** SecretAccessKey. */
  secretAccessKey?: Maybe<Scalars['String']['output']>
  /** SessionToken. */
  sessionToken?: Maybe<Scalars['String']['output']>
  /** Url. */
  url?: Maybe<Scalars['String']['output']>
}
export default class MapboxService {
  public constructor(
    private readonly getValidAccessToken: () => Promise<string>,
  ) {}

  private get s3ConfigUrl() {
    return `${mapboxBase}/s3-config`
  }

  private get deleteTilesetUrl() {
    return `${mapboxBase}/tilesets`
  }

  private get uploadTilesetFileUrl() {
    return `${mapboxBase}/upload/shapefile`
  }

  private get uploadGeoTiffFileUrl() {
    return `${mapboxBase}/upload/geotiff`
  }

  public async getS3Config(): Promise<IS3Config> {
    return this.fetchMapboxApi(this.s3ConfigUrl, 'GET')
  }

  public async deleteTileset(tilesetId: string): Promise<void> {
    return this.fetchMapboxApi(
      `${this.deleteTilesetUrl}/${tilesetId}`,
      'DELETE',
    )
  }

  public async uploadTilesetFile(
    projectId: string,
    fileName: string,
    fullFilePath: string,
  ): Promise<any> {
    return this.fetchMapboxApi(
      this.uploadTilesetFileUrl,
      'POST',
      {
        'Content-Type': 'application/json',
      },
      JSON.stringify({
        projectId,
        fileName,
        fullFilePath,
      }),
    )
  }

  public async uploadGeoTiffFile(
    projectId: string,
    s3Url: string,
    fileName: string,
  ): Promise<any> {
    return this.fetchMapboxApi(
      this.uploadGeoTiffFileUrl,
      'POST',
      {
        'Content-Type': 'application/json',
      },
      JSON.stringify({
        projectId,
        s3Url,
        fileName,
      }),
    )
  }

  private async fetchMapboxApi(
    route: string,
    method: string = 'GET',
    headers = {},
    body = undefined,
  ): Promise<any> {
    const accessToken = await this.getValidAccessToken()

    return ApiHelper.fetchJson(route, {
      method,
      mode: 'cors',
      headers: { ...headers, authorization: `Bearer ${accessToken}` },
      body,
    })
  }
}
